import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import SiteRenderer from "@/components/SiteRenderer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicSite() {
  const { slug } = useParams();
  const [site, setSite] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    axios.get(`${API}/sites/${slug}`).then(({ data }) => {
      setSite(data);
      document.title = data.seo?.title || data.name;
      axios.post(`${API}/sites/${slug}/event`, { type: "page_view", page: "home" }).catch(() => {});
    }).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div style={{ padding: 60, textAlign: "center", fontFamily: "Arial" }}>This site is not published.</div>;
  if (!site) return null;

  const assetUrl = (id) => `${API}/sites/${slug}/asset/${id}`;
  const onLead = async (form) => {
    try { await axios.post(`${API}/sites/${slug}/lead`, { ...form, source_page: "home" }); return true; }
    catch (e) { alert(e.response?.data?.detail || "Could not send."); return false; }
  };
  return <SiteRenderer site={site} assetUrl={assetUrl} onLead={onLead} />;
}
